import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LessonPlan } from '../_models/lessonPlan';
import { PlanMemberResponse } from '../_models/planMemberResponse';
import { PlanItem } from '../_models/planItem';

@Injectable({
  providedIn: 'root'
})
export class PlanService {

  baseUrl = environment.apiUrl;
  constructor(private http: HttpClient) { }

  getLessonPlans(): Observable<LessonPlan[]> {
    return this.http.get<LessonPlan[]>(this.baseUrl + 'plan/lessonPlans');
  }

  getLessonPlan(planId: number) {
    return this.http.get<LessonPlan>(this.baseUrl + 'plan/lessonPlan/' + planId);
  }

  getPlanItem(planItemId: number) {
    return this.http.get<PlanItem>(this.baseUrl + 'plan/planItem/' + planItemId);
  }

  planMemberRespond(planMemberResponse : PlanMemberResponse): Observable<PlanMemberResponse> {
    return this.http.post<PlanMemberResponse>(this.baseUrl + 'plan/lessonPlan/respond', planMemberResponse);
  }

  updateLessonPlan(lessonPlan: LessonPlan): Observable<LessonPlan> {
    var url = this.baseUrl + 'plan/lessonPlan';
    return this.http.put<LessonPlan>(url, lessonPlan);
  }
}
